<template>
  <div class="sponsors row">
    <a class="three columns" href="https://www.zapp.nl/anti-pest-club" target="_blank">
      <img src="../../assets/images/sponsors/logo_apc.png" alt="Anti Pest Club" />
    </a>
    <a class="three columns" href="https://www.zapp.nl/" target="_blank">
      <img src="../../assets/images/sponsors/logo_zapp.png" alt="NPO Zapp" />
    </a>
    <a class="three columns" href="https://www.eo.nl/" target="_blank">
      <img src="../../assets/images/sponsors/logo_eo.png" alt="EO" />
    </a>
    <a class="three columns" href="https://www.schoolenveiligheid.nl/" target="_blank">
      <img src="../../assets/images/sponsors/logo_sv.png" alt="School en Veiligheid" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'Sponsors'
}
</script>

<style scoped lang="scss">
.sponsors {
  align-items: center;
}
</style>
